import React, { Component } from 'react';
import './AddPersonalDataForm.css';
import clipboardTodo from '../../img/clipboardTodo.png';

class AddPersonalDataForm extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="addPersonalDataFormTitle">
                    <div className="col-xs-1"><img src={clipboardTodo}/></div>
                    <div className="col-xs-11">It seems like you visited us for the first time. We need a little more information about you.</div>
                </div>
                <div className="stepPersonalData addPersonalDataForm">
                    <div className="col-xs-6">
                        <div><label>Name:</label></div>
                        <div className="inputBlock"><input value="Ville" readOnly className="readOnlyInput" /></div>
                    </div>
                    <div className="col-xs-6">
                        <div><label>Surname:</label></div>
                        <div className="inputBlock"><input value="Valo" readOnly className="readOnlyInput"/></div>
                    </div>
                    <div className="col-xs-12">
                        <div><label>E-mail address (optional):</label></div>
                        <div className="inputBlock"><input type="email"/></div>
                    </div>
                    <div className="col-xs-8">
                        <div><label>Street name:</label></div>
                        <div className="inputBlock"><input/></div>
                    </div>
                    <div className="col-xs-4">
                        <div><label>Number:</label></div>
                        <div className="inputBlock"><input/></div>
                    </div>
                    <div className="col-xs-8">
                        <div><label>City:</label></div>
                        <div className="inputBlock"><input/></div>
                    </div>
                    <div className="col-xs-4">
                        <div><label>ZIP code:</label></div>
                        <div className="inputBlock"><input/></div>
                    </div>
                    <div className="col-xs-12">
                        <div><label>Contact number:</label></div>
                        <div className="inputBlock"><input/></div>
                    </div>
                </div>

                <div className="dataFormNavigation col-xs-12">
                    <div className="col-xs-6"></div>
                    <div className="col-xs-6"><div className="continueButton" onClick={this.props.nextStep}>Confirm</div></div>
                </div>
            </div>
        );
    }
}

export default AddPersonalDataForm;



// WEBPACK FOOTER //
// ./src/components/Step_4/AddPersonalDataForm.jsx